import React, { useEffect, useState } from 'react';
import { Typography, Button, Box, useMediaQuery, useTheme } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { checkAuthAndRedirect } from '../utils/auth';

const SubscriptionSuccessPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [windowDimensions, setWindowDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });
    };

    const checkAuth = async () => {
      const isAuthenticated = await checkAuthAndRedirect(navigate);
      if (!isAuthenticated) return;
    };

    checkAuth();

    window.addEventListener('resize', handleResize);

    // Get session_id from URL query parameters
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get('session_id');

    // Send request to backend
    if (sessionId) {
      const token = localStorage.getItem('token'); // Adjust this if you store the token differently
      
      axios.get(`${API_BASE_URL}/api/handle-subscription-success?session_id=${sessionId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      )
        .then(response => {
          console.log('Subscription success handled:', response.data);
        })
        .catch(error => {
          console.error('Error handling subscription success:', error);
        });
    }

    return () => window.removeEventListener('resize', handleResize);
  }, [location]);

  const handleSubscriptionManagement = () => {
    const token = localStorage.getItem('token');
    window.location.href = `${API_BASE_URL}/subscription-management?token=${token}`;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: '100vh',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        pt: isMobile ? 4 : 8, // Adjust top padding for mobile and desktop
      }}
    >
      <Confetti
        width={windowDimensions.width}
        height={windowDimensions.height}
        recycle={false}
        numberOfPieces={isMobile ? 200 : 500}
      />
      <Typography 
        variant="h1" 
        sx={{ 
          fontSize: isMobile ? '5rem' : '8rem', 
          mb: 2,
          animation: 'bobbing 2s ease-in-out infinite',
          '@keyframes bobbing': {
            '0%, 100%': {
              transform: 'translateY(0)',
            },
            '50%': {
              transform: 'translateY(-10px)',
            },
          },
        }}
      >
        🎉
      </Typography>
      <Typography variant="h2" gutterBottom sx={{ fontSize: isMobile ? '2rem' : '3rem' }}>
        Congratulations!
      </Typography>
      <Typography variant="h4" gutterBottom sx={{ fontSize: isMobile ? '1.5rem' : '2rem', px: 2 }}>
        You're now subscribed to Receipts AI
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, px: 2, maxWidth: '600px' }}>
        Get ready to revolutionize your receipt management experience!
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 2 }}>
        <Button
          component={Link}
          to="/dashboard"
          variant="contained"
          color="primary"
          size="large"
          fullWidth={isMobile}
        >
          Go to Dashboard
        </Button>
        <Button
          component={Link}
          to="/receipts"
          variant="outlined"
          color="primary"
          size="large"
          fullWidth={isMobile}
        >
          View Receipts
        </Button>
        <Button
          onClick={handleSubscriptionManagement}
          variant="outlined"
          color="secondary"
          size="large"
          fullWidth={isMobile}
        >
          Manage Subscription
        </Button>
      </Box>
    </Box>
  );
};

export default SubscriptionSuccessPage;